<template>
  <form>
    <md-card data-tour="advanced_rtmp_config">
      <md-card-header
        class="md-card-header-icon"
        :class="getClass(headerColor)"
      >
        <div class="card-icon">
          <md-icon>live_tv</md-icon>
        </div>
        <h4 class="title">
          RTMP
        </h4>
        <help-link :link="helpLink.link" title="rtmp"></help-link>
      </md-card-header>
      <md-card-content>
        <loading-spinner
          v-if="loadingFeature"
          title="RTMP Config"
        ></loading-spinner>
        <div class="md-layout" v-if="!loadingFeature">
          <div class="md-layout-item md-size-100">
            <inline-notification v-if="isWildcardChannel" v-model="isRtmpUrlChanged" type="warning" icon="warning" :message="rtmpWarningMessage"/>
            <md-field :class='{
              "md-invalid": $v.channel.rtmp.url.$error
            }'>
              <md-input
                class="full-width hide-overflow"
                data-tour="channel_rtmp_url"
                placeholder="URL"
                v-model="channel.rtmp.url"
                :disabled="!rtmpEnabled" 
                @blur="validate($v.channel.rtmp.url)"
                @change="onRtmpUrlChanged"
              ></md-input>
              <span v-if="!$v.channel.rtmp.url.requiredIfEnabled || !$v.channel.rtmp.url.requiredIfSecretKeySet" class="md-error">
                RTMP URL is required.
              </span>
              <span v-else-if="!$v.channel.rtmp.url.validUrlIfNotEmpty" class="md-error">
                Enter a valid RTMP URL.
              </span>
            </md-field>
            <md-field :class='{
              "md-invalid": $v.channel.rtmp.secretKey.$error
            }'>
              <md-input
                type="password"
                class="full-width hide-overflow"
                data-tour="channel_rtmp_streamkey"
                placeholder="Stream Key"
                v-model="channel.rtmp.secretKey"
                :disabled="!rtmpEnabled"
                @blur="validate($v.channel.rtmp.secretKey)"
              ></md-input>
              <span v-if="!$v.channel.rtmp.url.requiredIfEnabled || !$v.channel.rtmp.url.requiredIfUrl" class="md-error">
                Stream Key is required.
              </span>
            </md-field>
            <md-switch 
              class="md-layout-item md-size-100"
              v-model="channel.rtmp.enabled" 
              :disabled="!rtmpEnabled" 
              @change="validate($v.channel.rtmp.url);validate($v.channel.rtmp.secretKey)"
            >Automatically start RTMP when the Channel is activated</md-switch>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
import { HelpLinkTemplate, LoadingSpinner} from "@/fmComponents";
import helpLinks from "../../contextualHelpLinks.js";
import validationRules from "../../validationRules";
import InlineNotification from "@/fmComponents/InlineNotification";
export default {
  props: {
    channel: null,
    ogChannel: null,
    headerColor: {
      type: String,
      default: ""
    },
    rtmpEnabled: {
      type: Boolean,
      default: false
    },
    loadingFeature: {
      type: Boolean,
      default: true
    },
  },
  components: {
    "help-link": HelpLinkTemplate,
    LoadingSpinner,
    InlineNotification
  },
  computed: {
    validationError: function () {
      return this.$v.channel.rtmp.$anyError;
    },
    channelPattern: function() {
      return (this.channel || {}).channelIdPattern || "";
    },
    isDefaultChannel: function() {
      return this.channelPattern === "*";
    },
    isWildcardChannel: function() {
      return this.channelPattern.indexOf("*") >= 0;
    },
    rtmpWarningMessage: function() {
      if (this.isDefaultChannel) {
        return "Enabling RTMP on the default channel allows reusing the RTMP URL on multiple channels."
      } 
      return "Enabling RTMP on channels with the wildcard character asterisk (*) allows reusing the RTMP URL on multiple channels."
    }
  },
  data: () => ({
    helpLink: helpLinks.channelConfig.rtmp,
    isRtmpUrlChanged: false
  }),
  validations: () => {
    return validationRules;
  },
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    onRtmpUrlChanged: function() {
      if (this.channel && this.channel.rtmp && this.channel.rtmp.url) {
        this.isRtmpUrlChanged = true
      }
    },
    validate: function(input) {
      if (input && input.$touch) {
        input.$touch();
      }
    }
  },
  watch: {
    validationError(val) {
      this.$emit("validationErrorChanged", this, val);
    },
    channel() {
      // When the parent form is saved, we end up loading
      // a new channel object which will allow reseting
      // the warning message.
      this.isRtmpUrlChanged = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.md-error {
  // TODO: We need to clean up how we handle
  // error messages. The webhook modal appears
  // to be the only other component that uses
  // inline error messages. In the webhook
  // modal, this value needs to be -12px, however
  // in this component, the offset needs to be 
  // -6px. We need investigate why then 
  // make this a global value that will 
  // work in all cases where we use inputs.
  // The expected value from Vue Material
  // css is 22px
  bottom: -6px;
}
@media screen and (min-width: 1117px) {
  h4.title {
    display: inline-flex;
  }
  .contextual-help {
    display: inline-flex;
    float: right;
    margin-top: 21px;
  }
  /deep/ .contextual-help > a {
    padding-top: 2px;
  }
  .hide-overflow {
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>
